import Overtime from 'features/overtime/Overtime';
import { useTitle } from '../helpers';

/**
 * @page Absence page
 */
const OvertimePage = () => {
  useTitle('Сверхурочная работа');

  return (
    <div>
      <Overtime />
    </div>
  );
};

export default OvertimePage;
